import styled, { css } from 'styled-components'
import { customTheme } from '../../styles/theme'

interface IImageProps {
  direction: 'right' | 'top' | 'bottom';
}

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9999;

  background: rgba(35, 35, 35, .6)
;
`

export const Badge = styled.div`
  max-width: 180px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  position: absolute;
`

export const Image = styled.img<IImageProps>`
  position: relative;

  ${({ direction }) => {
    if (direction === 'right') {
      return css`
        right: -20%;
        top: 0px;

        @media (max-width: ${customTheme.breakpoints[1]}) {
          transform: scaleX(-1) rotate(260deg);
        }
      `
    }

    if (direction === 'bottom') {
      return css`
        right: -20%;
        top: 0px;

        @media (max-width: ${customTheme.breakpoints[1]}) {
          transform: scaleX(-1) rotate(260deg);
        }
      `
    }

    if (direction === 'top') {
      return css`
        right: -50%;
        top: 30%;
      `
    }
  }}
`

export const Description = styled.div`
  max-width: 250px;
  margin: 10px 0px;

  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #FFFFFF;
`

export const Button = styled.button`
  width: 78px;
  height: 60px;

  background: #FFFFFF;
  border: 2px solid #232323;
  box-sizing: border-box;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  font-weight: bold;
  font-size: 24px;
  line-height: 36px;
  color: #000000;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`
